// extracted by mini-css-extract-plugin
export default {"controls":"LetterGridItem_controls__1bBRt","grid":"LetterGridItem_grid__yc-Fr","gridItem":"LetterGridItem_gridItem__KUyMu"};